module.exports = __webpack_public_path__ + "static/media/wordmark-logo.0f5e6fec.png";